import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { buildErpGmsHandoffAuthUrl } from 'src/utils/portal-auth.util';

@Component({
  selector: 'app-business-links',
  templateUrl: './business-links.component.html',
  styleUrls: ['./business-links.component.css']
})
export class BusinessLinksComponent {
  readonly erpBusinessLoginUrl = buildErpGmsHandoffAuthUrl('login');
  readonly erpBusinessRegisterUrl = buildErpGmsHandoffAuthUrl('register');
  readonly gmsDashboardUrl: string;
  readonly isLoggedIn: boolean;

  constructor() {
    const base = environment.gmsUrl.replace(/\/$/, '');
    this.gmsDashboardUrl = `${base}/dashboard`;
    this.isLoggedIn = this.hasPortalSession();
  }

  /** Same idea as the old `currentUser` check, plus ERP JWT after portal SSO. */
  private hasPortalSession(): boolean {
    if (localStorage.getItem('mootori_access_token')?.trim()) {
      return true;
    }
    try {
      const raw = localStorage.getItem('user');
      if (!raw) return false;
      const u = JSON.parse(raw) as unknown;
      return u != null && typeof u === 'object';
    } catch {
      return false;
    }
  }
}
